import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from 'components/Common/MUICustomAutocomplete';

interface IBiteListOpts {
  formValues: any;
  setFormValues: any;
  setInvDomainOpts: any;
  setCountryOpts: any;
  selectedIndex: string;
  invDomainOpts: any;
  countryOpts: any;
  countryData: any;
  biteListPrimaryOpts: any;
  toClear: boolean;
}

const BiteListOptions: React.FC<IBiteListOpts> = ({
  biteListPrimaryOpts,
  selectedIndex,
  formValues,
  setFormValues,
  setCountryOpts,
  setInvDomainOpts,
  invDomainOpts,
  countryOpts,
  toClear,
}) => {
  const handleListNameSelect = async(e: any) => {
    const obj = {
      ...formValues,
      listName: e,
      invDomain: [],
      country: [],
    };
    setFormValues(obj);
    if (obj && obj.listName.length !== 0) {
      setInvDomainOpts({ isLoading: true, data: {} });
      setCountryOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listName: obj.listName,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.invstAgg.buckets);
          },
        );
      }
      setInvDomainOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleInvDomainSelect = async(e: any) => {
    const obj = {
      ...formValues,
      invDomain: e,
      country: [],
    };
    setFormValues(obj);
    if (obj && obj.invDomain.length !== 0) {
      setCountryOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        invDomain: obj.invDomain,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.invstAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.countryAgg.buckets);
            });
          },
        );
      }
      setCountryOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleCountrySelect = async(e: any) => {
    setFormValues({ ...formValues, country: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!biteListPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={biteListPrimaryOpts.data.countryAgg.buckets}
          placeholder='List Name'
          onChange={handleListNameSelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!invDomainOpts.isLoading ? invDomainOpts.data : []}
        placeholder='Investigative Domain'
        onChange={handleInvDomainSelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!countryOpts.isLoading ? countryOpts.data : []}
        placeholder='Country'
        onChange={handleCountrySelect}
        toClear={toClear}
      />
    </div>
  );
};

export default BiteListOptions;
